import { showPriceFromCentsWithCurrency } from './Price';

export const RECEIPT_PATH = '/receipt';
export const RECEIPT_POLL_WINDOW_MS = 60000;
const RECEIPT_POLL_DELAYS_MS = [2000, 3000, 5000];
const RECEIPT_POLL_INTERVAL_MS = 8000;

export const getReceiptPath = (token: string): string => {
    return `${RECEIPT_PATH}/${token}`;
};

export const isReceiptPath = (pathname: string): boolean => {
    return pathname === '/storesuccess' || pathname === RECEIPT_PATH || pathname.startsWith(`${RECEIPT_PATH}/`);
};

export const getSiteURLWithPath = (siteUrl: string, path: string): string => {
    try {
        const url = new URL(siteUrl);
        url.pathname = `${url.pathname.replace(/\/+$/, '')}${path}`;
        return url.toString();
    } catch (error) {
        return '';
    }
};

export const withQueryParam = (url: string, key: string, value: string): string => {
    try {
        const parsed = new URL(url);
        parsed.searchParams.set(key, value);
        return parsed.toString();
    } catch (error) {
        return url;
    }
};

export const getNextPollDelay = (attempt: number, elapsedMs: number): number | null => {
    const remaining = RECEIPT_POLL_WINDOW_MS - elapsedMs;
    if (remaining <= 0) {
        return null;
    }
    const delay = attempt < RECEIPT_POLL_DELAYS_MS.length ? RECEIPT_POLL_DELAYS_MS[attempt] : RECEIPT_POLL_INTERVAL_MS;
    return Math.min(delay, remaining);
};

export const formatReceiptMoney = (amount: number | null, currency: string | null): string => {
    if (typeof amount !== 'number' || amount === 0 || typeof currency !== 'string' || currency.length === 0) {
        return 'Free';
    }
    return showPriceFromCentsWithCurrency(amount, currency);
};

const plural = (count: number, word: string): string => {
    return `${count} ${word}${count === 1 ? '' : 's'}`;
};

export const getReceiptSummaryChips = (receipt: any): { id: string; label: string }[] => {
    const chips: { id: string; label: string }[] = [];
    const ticketCount = (receipt.tickets || []).reduce((sum: number, ticket: any) => {
        return sum + (ticket.lines || []).reduce((lineSum: number, line: any) => { return lineSum + (Number(line.quantity) || 0); }, 0);
    }, 0);
    if (ticketCount > 0) { chips.push({ id: 'receipt-tickets', label: plural(ticketCount, 'Ticket') }); }
    if ((receipt.products || []).length > 0) { chips.push({ id: 'receipt-products', label: plural(receipt.products.length, 'Product') }); }
    if (receipt.form) { chips.push({ id: 'receipt-form', label: '1 Form' }); }
    return chips.length > 1 ? chips : [];
};

export const formatReceiptAddress = (address: any): string[] => {
    if (!address) { return []; }
    const cityLine = [address.city, [address.state, address.postal_code].filter(Boolean).join(' ')].filter(Boolean).join(', ');
    return [address.line1, address.line2, cityLine, address.country].filter((part: string) => { return typeof part === 'string' && part.length > 0; });
};
